import React, { Component } from 'react';
import AlertBox, { Heading, SubHeading } from 'components/shared/AlertBox';
import { LabeledCheckbox } from 'components/shared/checkbox';
import InfoTooltip from 'components/shared/InfoTooltip';
import { Spinner } from 'ui';
import addModifiers from 'utils/add_modifiers';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';

class Modal extends Component {
  state = {
    notifyViaSms: false,
    notifyViaEmail: false,
    customSmsMessage: '',
    customEmailMessage: '',
    loading: false,
  };

  checkboxChange = ({ target }) => {
    this.setState({ [target.name]: target.checked });
  };

  inputChange = ({ target }) => {
    this.setState({ [target.name]: target.value });
  };

  sendReminder = () => {
    const { assignmentIds, onDismiss } = this.props;
    const {
      notifyViaSms,
      notifyViaEmail,
      customSmsMessage,
      customEmailMessage,
    } = this.state;

    const data = {
      selected_ids: assignmentIds,
      notify_via_sms: notifyViaSms,
      notify_via_email: notifyViaEmail,
      custom_sms_message: customSmsMessage,
      custom_email_message: customEmailMessage,
    };

    this.setState({ loading: true });

    request
      .post(routes.ASSIGNMENT_BULK_REMIND, data, { dataType: 'script' })
      .done(onDismiss);
  };

  get defaultMessage() {
    const { companyName } = this.props;
    return t('mailers.assignment.assignment_reminder.shared.passive_voice', {
      company: companyName,
    });
  }

  get disableSubmitButton() {
    const { notifyViaEmail, notifyViaSms } = this.state;
    return !(notifyViaEmail || notifyViaSms);
  }

  get cannotReceiveSmsNotice() {
    const { cannotReceiveSmsCount } = this.props;
    const allOrSome = this.disableSmsOption ? 'all' : 'some';

    return t(`reminder_modal.notify_via_text.cannot_receive_sms.${allOrSome}`, {
      count: cannotReceiveSmsCount,
    });
  }

  get disableSmsOption() {
    const { cannotReceiveSmsCount, assigneeCount } = this.props;
    return assigneeCount === cannotReceiveSmsCount;
  }

  render() {
    const { onDismiss, cannotReceiveSmsCount, remindAllUsers } = this.props;
    const { notifyViaEmail, notifyViaSms, customSmsMessage, loading } =
      this.state;
    const { disableSmsOption } = this;
    const textareaClass = addModifiers('NewInput', [
      'white',
      'fw',
      'multiLine',
    ]);

    return (
      <AlertBox styleName="ReminderModal" onDismiss={onDismiss}>
        <div className="ReminderModal-body">
          <Heading children={t('reminder_modal.title')} />
          <SubHeading children={t('reminder_modal.choose_a_method')} />

          <div className="FormGroup mt-24">
            <LabeledCheckbox
              onChange={this.checkboxChange}
              defaultValue={notifyViaEmail}
              name="notifyViaEmail"
              label={
                <span
                  className="ml-8"
                  children={t('reminder_modal.notify_via_email.title')}
                />
              }
            />
            <InfoTooltip
              tooltip={t('reminder_modal.notify_via_email.description')}
              className="ml-4"
            />

            <blockquote className="mt-10">
              <textarea
                name="customEmailMessage"
                className={textareaClass}
                placeholder={this.defaultMessage}
                rows="4"
                disabled={!notifyViaEmail}
                onChange={this.inputChange}
              />
            </blockquote>

            {notifyViaEmail && remindAllUsers && (
              <p className="small foot-note">
                <strong>{t('common.note')}:</strong>&nbsp;
                <span>{t('reminder_modal.notify_via_email.remind_all')}</span>
              </p>
            )}

            <LabeledCheckbox
              onChange={this.checkboxChange}
              defaultValue={notifyViaSms}
              disabled={disableSmsOption}
              name="notifyViaSms"
              label={
                <span
                  className="ml-8"
                  children={t('reminder_modal.notify_via_text.title')}
                />
              }
            />
            {!disableSmsOption && (
              <>
                <InfoTooltip
                  tooltip={t('reminder_modal.notify_via_text.description')}
                  className="ml-4"
                />
                <blockquote className="mt-10 mb-4">
                  <textarea
                    name="customSmsMessage"
                    className={textareaClass}
                    placeholder={this.defaultMessage}
                    rows="4"
                    maxLength="1000"
                    disabled={!notifyViaSms}
                    onChange={this.inputChange}
                  />
                </blockquote>
                <p className="small fs-i ta-r mb-4">
                  {customSmsMessage.length}
                  /1000
                </p>
                {notifyViaSms && cannotReceiveSmsCount > 0 && (
                  <p className="small foot-note">
                    <strong>{t('common.note')}:</strong>&nbsp;
                    <span>{this.cannotReceiveSmsNotice}</span>
                  </p>
                )}
              </>
            )}
            {disableSmsOption && (
              <p className="small foot-note fs-i mt-8">
                {this.cannotReceiveSmsNotice}
              </p>
            )}
          </div>
          <div className="d-f jc-e ai-c mt-24">
            <button
              type="button"
              className="u-linkBtn u-linkBtn--dark td-u"
              onClick={onDismiss}
              children={t('common.cancel')}
            />
            <button
              type="button"
              className="ml-16 CustomColor--backgroundColor CustomColor--buttonBoxShadow NewButton NewButton--tallAndWide"
              disabled={this.disableSubmitButton || loading}
              onClick={this.sendReminder}
            >
              {loading && <Spinner />}
              {t('reminder_modal.send_reminder')}
            </button>
          </div>
        </div>
      </AlertBox>
    );
  }
}

export default Modal;
